import type { SkuMaster } from "@/domain/types";

export const mockSkuMaster: SkuMaster[] = [
  {
    sku: "sku001",
    name: "演示产品001",
    asin: "DEMO-ASIN-001",
    msku: "sku001",
    upc: "88888888001",
    parentAsin: "DEMO-ASIN-001",
    parentSku: "grp001",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBA",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 25.99,
    listPrice: 25.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "炉头配件",
    lifecycle: "mature",
    launchDate: "2025-02-18",
    leadTimeDays: 35,
    safetyStockDays: 30,
    costFob: 6.5,
    costShipping: 1.02,
    costDelivery: 7.38,
    costCommission: 3.9,
    costStorage: 0.28,
    costReturn: 0.34,
    packageLength: 18,
    packageWidth: 15,
    packageHeight: 12,
    unitsPerBox: 10,
    packageWeight: 0.45,
    productUrl: "https://example.com/demo/sku001",
  },
  {
    sku: "sku002",
    name: "演示产品002",
    asin: "DEMO-ASIN-002",
    msku: "sku002",
    upc: "88888888002",
    parentAsin: "DEMO-ASIN-002",
    parentSku: "grp001",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBA",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 23.99,
    listPrice: 23.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "炉头配件",
    lifecycle: "mature",
    launchDate: "2025-02-18",
    leadTimeDays: 35,
    safetyStockDays: 30,
    costFob: 7.6,
    costShipping: 1.13,
    costDelivery: 7.71,
    costCommission: 3.6,
    costStorage: 0.47,
    packageLength: 18,
    packageWidth: 15,
    packageHeight: 12,
    unitsPerBox: 10,
    packageWeight: 0.48,
  },
  {
    sku: "sku003",
    name: "演示产品003",
    asin: "DEMO-ASIN-003",
    msku: "sku003",
    upc: "88888888003",
    parentAsin: "DEMO-ASIN-003",
    parentSku: "grp002",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 29.99,
    listPrice: 29.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "卡式炉",
    lifecycle: "growth",
    launchDate: "2025-11-06",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 10.5,
    costShipping: 2.2,
    costDelivery: 8.29,
    costCommission: 4.5,
    costStorage: 0.4,
    costReturn: 1.36,
    packageLength: 38,
    packageWidth: 32,
    packageHeight: 16,
    unitsPerBox: 2,
    packageWeight: 4.2,
    productUrl: "https://example.com/demo/sku003",
  },
  {
    sku: "sku004",
    name: "演示产品004",
    asin: "DEMO-ASIN-004",
    msku: "sku004",
    upc: "88888888004",
    parentAsin: "DEMO-ASIN-004",
    parentSku: "grp004",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBA",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 39.99,
    listPrice: 39.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "落地灶",
    lifecycle: "mature",
    launchDate: "2025-04-12",
    leadTimeDays: 45,
    safetyStockDays: 30,
    costFob: 12.5,
    costShipping: 2.98,
    costDelivery: 8,
    costCommission: 6,
    costStorage: 1.11,
    packageLength: 45,
    packageWidth: 35,
    packageHeight: 22,
    unitsPerBox: 1,
    packageWeight: 6.5,
  },
  {
    sku: "sku005",
    name: "演示产品005",
    asin: "DEMO-ASIN-005",
    msku: "sku005",
    upc: "88888888005",
    parentAsin: "DEMO-ASIN-005",
    parentSku: "grp005",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 165.99,
    listPrice: 165.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "受保护中",
    category: "结合炉",
    lifecycle: "growth",
    launchDate: "2026-01-08",
    leadTimeDays: 50,
    safetyStockDays: 30,
    costFob: 57,
    costShipping: 25.69,
    costDelivery: 30.69,
    costCommission: 24.9,
    costStorage: 2.8,
    packageLength: 68,
    packageWidth: 55,
    packageHeight: 42,
    unitsPerBox: 1,
    packageWeight: 18.5,
    productUrl: "https://example.com/demo/sku005",
  },
  {
    sku: "sku006",
    name: "演示产品006",
    asin: "DEMO-ASIN-006",
    msku: "sku006",
    upc: "88888888006",
    parentAsin: "DEMO-ASIN-006",
    parentSku: "grp006",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 105.99,
    listPrice: 105.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "落地灶",
    lifecycle: "growth",
    launchDate: "2025-05-10",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 30,
    costShipping: 13.74,
    costDelivery: 21.36,
    costCommission: 15.9,
    costStorage: 2,
    packageLength: 62,
    packageWidth: 48,
    packageHeight: 28,
    unitsPerBox: 1,
    packageWeight: 12.8,
  },
  {
    sku: "sku007",
    name: "演示产品007",
    asin: "DEMO-ASIN-007",
    msku: "sku007",
    upc: "88888888007",
    parentAsin: "DEMO-ASIN-007",
    parentSku: "grp007",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 85.98,
    listPrice: 85.98,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "OPR审核中",
    category: "落地灶",
    lifecycle: "mature",
    launchDate: "2025-08-14",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 23.8,
    costShipping: 13.2,
    costDelivery: 16.13,
    costCommission: 12.9,
    packageLength: 58,
    packageWidth: 42,
    packageHeight: 26,
    unitsPerBox: 1,
    packageWeight: 9.2,
  },
  {
    sku: "sku008",
    groupSku: "sku007",
    name: "演示产品007 (SHOP2)",
    asin: "DEMO-ASIN-008",
    msku: "sku008",
    upc: "88888888008",
    parentAsin: "DEMO-ASIN-008",
    parentSku: "grp008",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE2-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 85.99,
    listPrice: 85.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "落地灶",
    lifecycle: "mature",
    launchDate: "2025-08-14",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 23.8,
    costShipping: 13.2,
    costDelivery: 16.13,
    costCommission: 12.9,
    costReturn: 1.32,
    packageLength: 58,
    packageWidth: 42,
    packageHeight: 26,
    unitsPerBox: 1,
    packageWeight: 9.2,
  },
  {
    sku: "sku009",
    groupSku: "sku007",
    name: "演示产品007 (SHOP2-B)",
    asin: "DEMO-ASIN-009",
    msku: "sku009",
    upc: "88888888009",
    parentAsin: "DEMO-ASIN-009",
    parentSku: "grp008",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE2-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 86.99,
    listPrice: 86.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "落地灶",
    lifecycle: "mature",
    launchDate: "2025-08-14",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 23.8,
    costShipping: 13.2,
    costDelivery: 16.13,
    costCommission: 12.9,
    costReturn: 1.32,
    packageLength: 58,
    packageWidth: 42,
    packageHeight: 26,
    unitsPerBox: 1,
    packageWeight: 9.2,
  },
  {
    sku: "sku010",
    name: "演示产品010",
    asin: "DEMO-ASIN-010",
    msku: "sku010",
    upc: "88888888010",
    parentAsin: "DEMO-ASIN-010",
    parentSku: "grp010",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 149.99,
    listPrice: 149.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "双头灶",
    lifecycle: "mature",
    launchDate: "2025-06-01",
    leadTimeDays: 45,
    safetyStockDays: 30,
    costFob: 48,
    costShipping: 19.51,
    costDelivery: 30.61,
    costCommission: 22.5,
    costReturn: 16.66,
    packageLength: 72,
    packageWidth: 58,
    packageHeight: 36,
    unitsPerBox: 1,
    packageWeight: 16.5,
  },
  {
    sku: "sku011",
    name: "演示产品011",
    asin: "DEMO-ASIN-011",
    msku: "sku011",
    upc: "88888888011",
    parentAsin: "DEMO-ASIN-011",
    parentSku: "grp011",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBA",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 79.99,
    listPrice: 79.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "玻璃灶",
    lifecycle: "growth",
    launchDate: "2026-02-04",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 15.5,
    costShipping: 6.67,
    costDelivery: 11.38,
    costCommission: 12,
    costStorage: 0.81,
    packageLength: 48,
    packageWidth: 38,
    packageHeight: 22,
    unitsPerBox: 1,
    packageWeight: 7.8,
  },
  {
    sku: "sku012",
    name: "演示产品012",
    asin: "DEMO-ASIN-012",
    msku: "sku012",
    upc: "88888888012",
    parentAsin: "DEMO-ASIN-012",
    parentSku: "grp012",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 75.99,
    listPrice: 75.99,
    aPlus: "todo",
    aPlusAdvanced: "todo",
    installVideo: "todo",
    transparentPlan: "未注册",
    category: "煲仔炉",
    lifecycle: "new",
    launchDate: "2026-05-20",
    leadTimeDays: 45,
    safetyStockDays: 30,
    costFob: 21,
    costShipping: 6.83,
    costDelivery: 13.72,
    costCommission: 11.4,
    packageLength: 55,
    packageWidth: 42,
    packageHeight: 28,
    unitsPerBox: 1,
    packageWeight: 8.5,
  },
  {
    sku: "sku013",
    name: "演示产品013",
    asin: "DEMO-ASIN-013",
    msku: "sku013",
    upc: "88888888013",
    parentAsin: "DEMO-ASIN-013",
    parentSku: "grp013",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBA",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 61.99,
    listPrice: 61.99,
    aPlus: "todo",
    aPlusAdvanced: "todo",
    installVideo: "todo",
    transparentPlan: "未注册",
    category: "双头灶",
    lifecycle: "new",
    launchDate: "2026-04-01",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 15.5,
    costShipping: 6.57,
    costDelivery: 18.6,
    costCommission: 9.3,
    costStorage: 7.09,
    packageLength: 42,
    packageWidth: 35,
    packageHeight: 20,
    unitsPerBox: 1,
    packageWeight: 5.5,
  },
  {
    sku: "sku014",
    name: "演示产品014",
    asin: "DEMO-ASIN-014",
    msku: "sku014",
    upc: "88888888014",
    parentAsin: "DEMO-ASIN-014",
    parentSku: "grp014",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 119.99,
    listPrice: 119.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "桌面炉",
    lifecycle: "growth",
    launchDate: "2026-03-10",
    leadTimeDays: 45,
    safetyStockDays: 30,
    costFob: 54.7,
    costShipping: 14.97,
    costDelivery: 17.28,
    costCommission: 18,
    packageLength: 65,
    packageWidth: 52,
    packageHeight: 32,
    unitsPerBox: 1,
    packageWeight: 14.2,
  },
  {
    sku: "sku015",
    name: "演示产品015",
    asin: "DEMO-ASIN-015",
    msku: "sku015",
    upc: "88888888015",
    parentAsin: "DEMO-ASIN-015",
    parentSku: "grp015",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE2-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 159.99,
    listPrice: 159.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "桌面炉",
    lifecycle: "growth",
    launchDate: "2026-01-16",
    leadTimeDays: 45,
    safetyStockDays: 30,
    costFob: 69.7,
    costShipping: 21.72,
    costDelivery: 18.98,
    costCommission: 24,
    packageLength: 72,
    packageWidth: 58,
    packageHeight: 36,
    unitsPerBox: 1,
    packageWeight: 18.8,
  },
  {
    sku: "sku016",
    name: "演示产品016",
    asin: "DEMO-ASIN-016",
    msku: "sku016",
    upc: "88888888016",
    parentAsin: "DEMO-ASIN-016",
    parentSku: "grp016",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 289.99,
    listPrice: 289.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "受保护中",
    category: "碳炉",
    lifecycle: "growth",
    launchDate: "2025-10-04",
    leadTimeDays: 50,
    safetyStockDays: 30,
    costFob: 87.78,
    costShipping: 30.91,
    costDelivery: 47.92,
    costCommission: 43.5,
    costReturn: 15.25,
    packageLength: 85,
    packageWidth: 62,
    packageHeight: 48,
    unitsPerBox: 1,
    packageWeight: 28.5,
  },
  {
    sku: "sku017",
    name: "演示产品017",
    asin: "DEMO-ASIN-017",
    msku: "sku017",
    upc: "88888888017",
    parentAsin: "DEMO-ASIN-017",
    parentSku: "grp017",
    linkType: "main",
    saleStatus: "active",
    fulfillment: "FBM",
    store: "DEMO-STORE2-US",
    marketplace: "US",
    siteId: "site_demo",
    price: 39.99,
    listPrice: 39.99,
    aPlus: "done",
    aPlusAdvanced: "done",
    installVideo: "done",
    transparentPlan: "已注册",
    category: "火箭炉",
    lifecycle: "growth",
    launchDate: "2026-02-22",
    leadTimeDays: 40,
    safetyStockDays: 30,
    costFob: 18,
    costShipping: 3.79,
    costDelivery: 9.91,
    costCommission: 6,
    packageLength: 35,
    packageWidth: 28,
    packageHeight: 18,
    unitsPerBox: 2,
    packageWeight: 3.2,
  },
];